$("quotify-button button").click(function () {
  // let button = $('button');
  // console.log(button,"button-----click");
  setTimeout(function () {
    console.log(document.getElementById("quotify-frame"), "inframe");

    if (document.getElementById("quotify-frame") !== null) {
      console.log(
        document.getElementById("quotify-frame").content,
        "inframe content"
      );
    }
  }, 2000);
});
$.get(
  "https://ipinfo.io",
  function (response) {
    console.log(response, "response");
    console.log(response.city, "response.city");
    console.log(response.country, "coutryName");

    if (response.country == "MX") {
      console.log("show mexico form");
    } else {
      console.log("show US form");

      console.log($(".shadow"));
    }
  },
  "jsonp"
);
